var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.large ? 'font-weight-bold' : '',style:(("color: var(--color-heading-soft); font-size: " + (_vm.large ? 52 : 12) + "pt;"))},[_vm._v(" Total: "+_vm._s(_vm.total)+" "+_vm._s(_vm.total == 1 ? "Student" : "Students")+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }